
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceExportExcel } from 'src/app/core/services/export.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-shift-pickup-point-mapping',
  templateUrl: './shift-pickup-point-mapping.component.html',
  styleUrls: ['./shift-pickup-point-mapping.component.scss']
})
export class ShiftPickupPointMappingComponent implements OnInit {

  _mFormGroup: FormGroup;
  mCity = new FormControl('');
  mSite = new FormControl('');
  mFilterType = new FormControl('');
  cityId: any;
  cities: any = [];
  sites: any = [];
  shifts: any = [];
  showBy = [{ name: 'COMMON POINT', type: 'C' }, { name: 'HOME POINT', type: 'H' }];
  selectedSite: any = '';
  rows = [];
  showMappings: boolean = false;
  unPushedValues: any[] = [];
  showFlag: boolean = false
  selectedType: string = 'c';
  shiftmapping: any = [];
  mappingdata: any = [];
  previousSelections: any = { city: null, site: null, filterType: null };

  constructor(
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private readonly serviceExportExcel: ServiceExportExcel,
    private readonly localStorage: ServiceLocalStorage,
    private ngxLoader: NgxUiLoaderService) {
  }

  ngOnInit() {
    this._mFormGroup = this.fb.group({
      'city': this.mCity,
      'site': this.mSite,
      'filterType': this.mFilterType
    });
    this.loadCities();
  }

  loadCities(restorePrevious = false) {
    let companyId = +this.localStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + companyId, success => {
      this.cities = success.body;
      if (this.cities && this.cities.length > 0) {
        const cityId = restorePrevious && this.previousSelections.city ? this.previousSelections.city : this.cities[0].locationId;
        setTimeout(() => {
          this.mCity.setValue(cityId);
        }, 0);
        this.getSitesByCityId(cityId, restorePrevious);
      }
    }, (error) => {
    });
  }

  getSitesByCityId(event, restorePrevious = false) {
    const cityId = event.target ? event.target.value : event;
    if (!cityId) return;
    this.showFlag = false;
    this.apiService.doGetRequestWithResponse(ApiConstants.getserchsitelist + cityId, (success) => {
      if (success.status == 200) {
        this.sites = success.body;
        if (this.sites && this.sites.length > 0) {
          const siteId = restorePrevious && this.previousSelections.site ? this.previousSelections.site : this.sites[0].siteId;
          const filterType = restorePrevious && this.previousSelections.filterType ? this.previousSelections.filterType : this.showBy[0].type;
          this.mSite.setValue(siteId);
          this.selectedSite = siteId;
          this.mFilterType.setValue(filterType);
        }
      } else {
        this.sites = [];
        this.notifyService.showInfo("No sites found for the selected city", null);
      }
    },
      (error) => {
      });
  }

  showMapping(selectedval) {
    this.unPushedValues = [];
    this.rows = [];
    if (selectedval == undefined) {
      this.notifyService.showInfo("Please select pickup point type!", null);
    } else {
      this.selectedType = selectedval;
      this.getShiftTime();
      this.showFlag = true;
    }
  }

  getShiftTime() {
    this.shifts = [];
    this.unPushedValues = [];
    this.rows = [];
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getShiftsBySiteAndTypeV3}${this.mSite.value}&shifttype=General`,
      (success) => {
        this.ngxLoader.stop();
        if (success?.body) {
          this.showMappings = true;
          this.shifts = success.body.map(shift => ({
            id: shift.shiftTimeId,
            value: `${shift.shiftTime} ${shift.logType}`
          }));
          this.rows = this.shifts;
          this.getMapping();
        } else {
          this.shifts = [];
          this.notifyService.showInfo("No data found", null);
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.shifts = [];
      }
    );
  }

  isAllChecked() {
    return this.rows.every(_ => _.state);
  }

  checkAll(checks) {
    if (checks.checked) {
      this.rows.forEach(x => {
        x.state = true;
        this.onValueChecked({ checked: true }, x);
      })
    }
  }

  onValueChecked(checked, sel) {
    if (checked.checked) {
      this.rows = this.rows.filter(r => r.id !== sel.id);
      this.unPushedValues.push(sel);
    }
  }

  unCheckAll(checks) {
    if (!checks.checked) {
      this.unPushedValues.forEach(x => {
        x.state = false;
        this.onSelValuesChecked({ checked: false }, x);
      })
    }
  }

  moveItemToRows(unselect) {
    this.rows.push(unselect);
    this.unPushedValues = this.unPushedValues.filter(r => r.id !== unselect.id);
  }

  onSelValuesChecked(checked, unselect) {
    if (!checked.checked) {
      this.moveItemToRows(unselect);
    }
  }

  onSelValueChecked(checked, unselect) {
    if (!checked.checked) {
      this.moveItemToRows(unselect);
    }
  }

  saveMapping() {
    if (!this.selectedType) {
      this.notifyService.showWarning("Please select pickup point type!", null);
      return;
    }

    if (!this.mSite.value) return;
    this.previousSelections = {
      city: this.mCity.value,
      site: this.mSite.value,
      filterType: this.mFilterType.value
    };
    this.showFlag = false;
    const pushedids = this.unPushedValues.map(item => +item.id);
    this.apiService.doPostRequestWithResponse(
      `${ApiConstants.shiftPickPoint}?siteid=${this.selectedSite}&shifttimeid=${pushedids}&type=${this.selectedType}`,
      '',
      (success) => {
        const isUpdated = success.status === 201;
        const message = isUpdated ? success.body.message : "Mapping removed successfully!";
        this.notifyService.showSuccess(message, null);
        this.resetForm();
      },
      (error) => {
        this.notifyService.showError("Failed to Updated!", null);
      }
    );
  }

  resetForm() {
    this.showMappings = false;
    this.unPushedValues = [];
    this.rows = [];
    this.shiftmapping = [];
    this.loadCities(true);
  }

  onsitechange(event) {
    this.showFlag = false;
    this.rows = [];
    this.unPushedValues = [];
    this.selectedSite = event.target.value;
  }

  getMapping() {
    this.unPushedValues = [];
    if (!this.mSite.value) return;
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getShiftPickPoint}?siteid=${this.selectedSite}&type=${this.selectedType}`,
      (success) => {
        if (success.status === 200) {
          const matchingShifts = success.body
            .filter(shiftmap => this.selectedType === shiftmap.type)
            .map(shiftmap => ({
              id: shiftmap.shift.shiftTimeId,
              value: `${shiftmap.shift.shiftTime} ${shiftmap.shift.logType}`,
              state: 'checked'
            }));

          this.rows = this.rows.filter(r => !matchingShifts.some(s => s.id === r.id));
          this.unPushedValues.push(...matchingShifts);
        }
      },
      (error) => {
        this.notifyService.showError("Error in Fetching Mapping!", null);
      }
    );
  }

  exportAsXLSX(): void {
    this.serviceExportExcel.exportAsExcelFile(this.mappingdata, 'ShiftMaping');
  }
}
